export default __webpack_public_path__ + "de39e9c5f4cedb2ffcb31337f6372120.webp";